module.exports = __webpack_public_path__ + "static/img/menu16.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu16.png
// module id = 102
// module chunks = 0